<template>
  <div class="modal-content">
    <div class="modal-header">
      <h5 class="modal-title">Recuperar Senha</h5>
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <form @submit.prevent="recuperar" autocomplete="off">
          <div class="row">
              <div class="col-md-12" :class="{'has-danger': errors.has('username')}">
                  <div class="form-group">
                      <label for="cpf">Nome de usuario (username)</label>
                      <input id="username" name="username" class="form-control"
                        v-validate="'required'"
                        v-model="username">
                      <div v-if="errors.has('username')" class="help-block form-text text-muted form-control-feedback">
                        {{errors.first('username')}}
                      </div>
                      <small class="form-text text-muted">Caso esqueceu username (enviar email ou ligar para central 21 2263-9325)</small>
                  </div>
              </div>
          </div>
          <div class="row">
              <div class="col text-right mb-2">
                <div class="btn-login">
                  <button type="button" @click.stop.prevent="voltar" class="btn btn-outline-secondary" data-dismiss="modal">Voltar</button>
                  <button type="submit" class="btn btn-primary">Recuperar</button>
                </div>
              </div>
          </div>
      </form>
    </div>
  </div>
</template>
<script>
import * as http from 'axios'

export default {
  data () {
    return {
      username: null
    }
  },
  methods: {
    async recuperar () {
      this.$validator.validateAll()
        .then(async result => {
          if (result) {
            try {
              let response = await http.post('/auth/recuperarPassword', {'username': this.username})
              this.$store.dispatch('showSuccessMsg', {
                body: response.data.message
              })
              this.$emit('openModal', 'login')
            } catch (error) {
              this.$toasted.show('O nome de usuário não foi encontrado!', {
                icon: { name: 'fa-exclamation-triangle' },
                type: 'error',
                theme: 'bubble',
                action: {
                  text: 'FECHAR',
                  onClick: (e, toastObject) => {
                    toastObject.goAway(0)
                  }
                }
              })
            }
          }
        })
    },
    voltar () {
      console.log('ROUTER ', this.$route)
      if (this.$route.name === 'Login') {
        window.$('#drAcheiModal').modal('hide')
      } else {
        this.$emit('changeTo', 'login')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/EsqueciSenhaCliente.vue